import { ListOrderType } from '@epicuro-next/data/engagement/engagement-models';
import { PulseOrderType } from 'models-common';

export function mapListOrderType(orderType: PulseOrderType): ListOrderType {
  switch (orderType) {
    case PulseOrderType.None:
      return ListOrderType.None;
    case PulseOrderType.Now:
      return ListOrderType.Now;
    case PulseOrderType.Future:
      return ListOrderType.Future;
    case PulseOrderType.Any:
      return ListOrderType.Any;
  }
}
